// extracted by mini-css-extract-plugin
module.exports = {"info__paragraph":"infoBarSmall_info__paragraph__3gK9M","info":"infoBarSmall_info__2f6Gb","slide":"infoBarSmall_slide__U5_DR"};